export const SENSITIVITY_PANEL_ORDER_KEY = 'sensitivityPanelOrder';
export const KEY_FUNCTION_PANEL_ORDER_KEY = 'keyFunctionPanelOrder';

export const readPanelOrder = (key, fallback) => {
  try {
    return window.localStorage.getItem(key) || fallback;
  } catch {
    return fallback;
  }
};

export const writePanelOrder = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // 本地存储不可用时，设置页仍保留本次会话中的选择。
  }
};
